module.exports = __webpack_public_path__ + "static/media/snta_logo.4708da31.svg";